import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=999fff3e&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=999fff3e&scoped=true&lang=css&"
import style1 from "./ForgotPassword.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999fff3e",
  null
  
)

export default component.exports